// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3SuOB","footer__inner":"style_footer__inner__1QNyc"};